module.exports = __webpack_public_path__ + "media/images/pc/stores/utsunomiya/utsunomiya_concept_01-3c4c6352b14875855380ecb615594436.jpg";